export default __webpack_public_path__ + "static/106-3fbe02c6f6bd046f15e0856c9cb22cd0.jpg";